import { Dispatch, MouseEvent, SetStateAction } from 'react';
import { RouteProps, useNavigate } from 'react-router-dom';

export const useToggleUserMenu = (
  toggleFn: Dispatch<SetStateAction<HTMLElement | null>>,
  close: boolean = false,
  element?: RouteProps
): ((event: MouseEvent<HTMLElement>) => void) => {
  const navigate = useNavigate();
  return (event: MouseEvent<HTMLElement>) => {
    toggleFn(close ? null : event.currentTarget);
    if (element) {
      navigate(element.path as string);
    }
  };
};
